import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AuthInterceptorService } from './features/auth/services/auth-interceptor.service';
import { LoaderInterceptor } from './shared/loader/loader.interceptor';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NZ_CONFIG, NzConfig } from 'ng-zorro-antd/core/config';

// Global ng-zorro defaults: every nz-select uses 44px option height so AntD's
// virtual list calculations match the actual rendered item size. Combined with
// CSS max-height of ~200px (4 items), short lists fit perfectly without scroll
// and longer lists get a slim scrollbar automatically.
const ngZorroConfig: NzConfig = {
  select: {
    nzOptionHeightPx: 44,
  },
};

@NgModule({
  imports: [
    AppComponent,
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    BsDropdownModule.forRoot(),
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      timeOut: 3000,
      progressBar: true,
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
    { provide: NZ_CONFIG, useValue: ngZorroConfig },
  ],
})
export class AppModule {}
